import React from 'react';

// Footer enligt CHills Visuella-redesign
export const Footer = () => {
  return (
    <footer className="bg-cv-dark text-cv-base" style={{ padding: 'clamp(56px,9vw,80px) clamp(20px,5vw,32px) 40px' }}>
      <div className="max-w-[1100px] mx-auto">
        <div className="grid gap-10 mb-16" style={{ gridTemplateColumns: 'repeat(auto-fit,minmax(min(100%,220px),1fr))' }}>
          <div className="flex flex-col gap-[18px]">
            <span className="font-serif text-2xl tracking-[0.14em]">
              CHills <em className="not-italic font-normal">visuella</em>
            </span>
            <p className="m-0 text-sm leading-[1.75] text-cv-faint max-w-[38ch]">
              Vi skapar tidlösa, vackra upplevelser genom genomtänkt design och kärleksfull renovering.
            </p>
          </div>

          <div className="flex flex-col gap-4">
            <h4 className="m-0 text-xs tracking-[0.3em] uppercase font-normal" style={{ color: '#8a7a68' }}>Tjänster</h4>
            <ul className="m-0 p-0 list-none flex flex-col gap-2.5 text-sm text-cv-edge">
              <li>Möbelrenovering</li>
              <li>Event &amp; Dukning</li>
              <li>Skyltfönster</li>
              <li>Grafisk Design</li>
            </ul>
          </div>

          <div className="flex flex-col gap-4">
            <h4 className="m-0 text-xs tracking-[0.3em] uppercase font-normal" style={{ color: '#8a7a68' }}>Följ oss</h4>
            <div className="flex flex-col gap-2.5">
              <a
                href="https://www.facebook.com/profile.php?id=61568666219208"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm tracking-[0.12em] text-cv-edge no-underline hover:text-cv-base transition-colors"
              >
                Facebook
              </a>
              <a
                href="https://www.instagram.com/chills_visuella/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm tracking-[0.12em] text-cv-edge no-underline hover:text-cv-base transition-colors"
              >
                Instagram
              </a>
            </div>
          </div>
        </div>

        <div className="pt-7 border-t text-center" style={{ borderColor: '#3a332a' }}>
          <p className="m-0 text-[13px] tracking-[0.1em]" style={{ color: '#8a7a68' }}>
            © 2025 CHills Visuella. Skapad med passion för tidlös design.
          </p>
        </div>
      </div>
    </footer>
  );
};
